import { render, staticRenderFns } from "./TaskServicesGlobalConfiguration.vue?vue&type=template&id=0d150f02&scoped=true&"
import script from "./TaskServicesGlobalConfiguration.vue?vue&type=script&lang=ts&"
export * from "./TaskServicesGlobalConfiguration.vue?vue&type=script&lang=ts&"
import style0 from "./TaskServicesGlobalConfiguration.vue?vue&type=style&index=0&id=0d150f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d150f02",
  null
  
)

export default component.exports